import type { Permission } from '@mc/shared/permissions';

import type { IconName } from '../components/ui/Icon';

export interface NavItem {
  key:
    | 'today'
    | 'agenda'
    | 'patients'
    | 'clinical'
    | 'payments'
    | 'reports'
    | 'operations'
    | 'inventory'
    | 'settings';
  to: string;
  icon: IconName;
  /** Alcanza con uno; vacío = todos (Mi día). */
  permissions: readonly Permission[];
}

/** RF-GEN-02: el rail, en este orden, filtrado por los permisos del rol. */
export const NAV: readonly NavItem[] = [
  { key: 'today', to: '/my-day', icon: 'sun', permissions: [] },
  { key: 'agenda', to: '/agenda', icon: 'agenda', permissions: ['agenda.view', 'agenda.view_own'] },
  {
    key: 'patients',
    to: '/patients',
    icon: 'pacientes',
    permissions: ['patients.view_admin', 'patients.view_clinical', 'patients.view_lab'],
  },
  { key: 'clinical', to: '/visit', icon: 'diente', permissions: ['clinical.notes.write'] },
  {
    key: 'payments',
    to: '/billing',
    icon: 'pagos',
    // El profesional entra solo a su producción (RF-PROD-07).
    permissions: ['ledger.view', 'cash.own', 'cash.view_all', 'compensation.view_own'],
  },
  { key: 'reports', to: '/reports/money', icon: 'informes', permissions: ['reports.view'] },
  {
    key: 'operations',
    to: '/operations',
    icon: 'target',
    permissions: ['ops.board', 'ops.journey', 'ops.issues.write', 'ops.protocols.view'],
  },
  { key: 'inventory', to: '/inventory', icon: 'inventario', permissions: ['inventory.view'] },
  {
    key: 'settings',
    to: '/settings/branches',
    icon: 'ajustes',
    permissions: [
      'settings.manage',
      'users.manage',
      'providers.manage',
      'catalog.manage',
      'clinical.templates.manage',
    ],
  },
];

export const visibleNav = (permissions: readonly string[]): NavItem[] =>
  NAV.filter(
    (item) => item.permissions.length === 0 || item.permissions.some((p) => permissions.includes(p)),
  );
